export const AssociateFilterReducer = (state, action) => {
    switch (action.type) {
        case 'SELECT_STATE':
            return action.state
        case 'REMOVE_STATE':
            return state.filter(value => value !== action.state)
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/associate/reducers/AssociateFilterReducer.js